import { Column } from 'react-table';

import { setColumnWidth } from '../../../../../../lib/common';
import { UserGradeHistoryItemType } from '../types';

export const columns = (data: { list: UserGradeHistoryItemType[] }): Column[] => {
  const { list } = data;
  return [
    {
      accessor: 'createDate',
      Header: '날짜',
      width: setColumnWidth(list, 'createDate'),
    },
    {
      accessor: 'gradeCreatePeriod',
      Header: '등급 산정 기간',
      width: setColumnWidth(list, 'gradeCreatePeriod'),
    },
    {
      accessor: 'gradeName',
      Header: '등급',
      width: setColumnWidth(list, 'gradeName'),
    },
  ];
};
